import { render, staticRenderFns } from "./xq52.vue?vue&type=template&id=ad3b98f4&scoped=true"
import script from "./xq52.vue?vue&type=script&lang=js"
export * from "./xq52.vue?vue&type=script&lang=js"
import style0 from "./xq52.vue?vue&type=style&index=0&id=ad3b98f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3b98f4",
  null
  
)

export default component.exports